import mod from "-!./component.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./component.js?vue&type=script&lang=js&external"